export function routePatternToRegExp(routePattern: string): RegExp {
  const escaped = routePattern
    .split('*')
    .map(part => part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('.*');
  return new RegExp(`^${escaped}$`);
}
